<template>
  <div>
    <Layout />
    <v-container grid-list-md>
      <notifications position="bottom center" />
      <v-layout row wrap>
        <v-flex xs12 class="headline">Total: {{total}}</v-flex>
        <v-flex xs12 sm4 md4 v-for="item in items" :key="item.id">
          <v-card :loading="loading" class="mx-auto my-12" max-width="374">
            <v-card-title>PEDIDO N°: {{item.id}}</v-card-title>

            <v-card-text>
              <v-row align="center" class="mx-0">
                <div class="grey--text">{{formatDate(item.created_at)}}</div>
              </v-row>

              <div class="my-4 subtitle-1">OBS:</div>

              <div>{{item.obs}}</div>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <v-card-title
              v-for="it in item.items"
              :key="it.id"
            >ITEM:{{it.product_id}} QTD: {{it.qty}}</v-card-title>

            <v-card-actions>
              <v-btn color="success lighten-2" @click="finish(item.id)">Pronto</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    "pagination.page": {
      handler() {
        this.getList();
      },
      deep: true,
    },
    search: function () {
      this.debounceInput();
    },
  },
  created() {
    this.getList();
    this.todo();
  },
  methods: {
    todo: function () {
      this.intervalid1 = setInterval(
        function () {
          
        this.getList();
        }.bind(this),
        10000
      );
    },
    getList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/orders/kitchen`)
          .then((response) => response.data)
          .then((json) => {
            setTimeout(() => {
              this.loading = false;
              this.items = json.items;
              this.total = json.total;

              console.log("ITEM", this.items);
            }, 1000);
          })
          .catch(() => (this.loading = false));
      });
    },

    finish(id) {
      if (confirm(`Deseja realmente finalizar o pedido ${id}?`)) {
        this.$http.put(`/orders/kitchen/${id}`).then((response) => {
          this.$notify({
            title: `Pedido finalizado`,
            type: "success",
          });
          this.getList();
        });
      }
    },
    formatDate: (date) => (date ? moment(date).format("DD/MM/YYYY H:m:S") : ""),
    debounceInput: _.debounce(function () {
      setTimeout(() => {
        this.getList();
      }, 200);
    }, 400),
  },
};
</script>
